import { useQueryClient } from 'react-query';
import { createQueryData } from '../helpers/createQueryData';
import { getDesksEndPoint } from './constants';

const {
  useQuery: useDeskNamesFetch,
  createKey: createDeskNamesQueryKeys,
  fn: fetchDeskNames,
} = createQueryData({
  endPoint: getDesksEndPoint,
});

const useDeskNamesQuery = ({
  params: { serviceCompanyId } = {},
  options,
} = {}) =>
  useDeskNamesFetch({
    params: { serviceCompanyId },
    options: {
      enabled: Boolean(serviceCompanyId),
      staleTime: 1000 * 60,
      ...options,
    },
  });

const { useQuery: useCheckDeskBusyFetch } = createQueryData({
  endPoint: 'Acceptance/check_desk_busy',
});

const useCheckDeskBusyQuery = ({ params: { deskId } = {}, options } = {}) =>
  useCheckDeskBusyFetch({
    params: { deskId },
    options: { enabled: Boolean(deskId), ...options },
  });

const useRefetchDeskNames = () => {
  const queryClient = useQueryClient();
  return () => queryClient.refetchQueries([getDesksEndPoint], { active: true });
};

export {
  useDeskNamesQuery,
  createDeskNamesQueryKeys,
  fetchDeskNames,
  useCheckDeskBusyQuery,
  useRefetchDeskNames,
};
